module.exports = "/_next/static/images/SouthBouy-2023c93a6efa8ac8d9fb4ea58fac1447.svg";